import { RowClassParams } from 'ag-grid-community'
import { AccountInfo } from '../AccountFilter/types'

/**
 * Determines which CSS class should be applied to a row based on account properties
 * - highDiffAccount: For accounts with high difference (greater than minDiff)
 * - focusAccount: For manually selected accounts
 * - commentAccount: For accounts with comment when comment filter is enabled
 */
export const getRowClass = (
  params: RowClassParams,
  selectedAccountIds: Set<number>,
  accounts: AccountInfo[],
  minDiff: number,
  enableCommentFilter: boolean
): string | undefined => {
  const accountId = params.data?.accountId as number | undefined
  if (!accountId) {
    return undefined
  }

  // Check if it is selected
  if (selectedAccountIds.has(accountId)) {
    return 'focusAccount'
  }

  // Check if account has high diff
  const account = accounts.find((acc) => acc.accountId === accountId)
  if (
    account &&
    account.difference !== null &&
    account.difference !== undefined
  ) {
    if (Math.abs(account.difference) > Math.abs(minDiff)) {
      return 'highDiffAccount'
    }
  }

  if (enableCommentFilter) {
    const comment = params.data?.comment
    if (typeof comment === 'string' && comment.trim().length > 0) {
      return 'commentAccount'
    }
  }

  return undefined
}

/**
 * Creates a callback function for getRowClass that can be used directly in AG Grid
 */
export const createGetRowClassCallback = (
  selectedAccountIds: Set<number>,
  accounts: AccountInfo[],
  minDiff: number,
  enableCommentFilter: boolean
) => {
  return (params: RowClassParams): string | undefined => {
    return getRowClass(
      params,
      selectedAccountIds,
      accounts,
      minDiff,
      enableCommentFilter
    )
  }
}
